import React from "react";
import { ResponsiveLine } from "@nivo/line";
import { Forecast } from "../SummaryShipmentTable/SummaryShipmentTable";
import { formatNumbersWithCommas } from "../../../constants/utils";

type SummaryShipmentLineChartProps = {
  forecasts: Forecast[];
};

type Plot = {
  x: string;
  y: string;
};
export const transformDataForChart = (forecasts: Forecast[]) =>
  forecasts.reduce(
    (acc, forecast) => {
      const dateParts = forecast.date.split(" ");
      const month = dateParts[0].substring(0, 3);
      const date = `${month} ${dateParts[1]}`;
      const currentForecastPlot = {
        x: date,
        y: forecast.currentSummary,
      };
      const previousForecastPlot = {
        x: date,
        y: forecast.previousSummary,
      };
      acc.previousForecasts.push(previousForecastPlot);
      acc.currentForecasts.push(currentForecastPlot);
      return acc;
    },
    {
      previousForecasts: [] as Array<Plot>,
      currentForecasts: [] as Array<Plot>,
    },
  );
const SummaryShipmentPlanLineChart = ({
  forecasts,
}: SummaryShipmentLineChartProps) => {
  const transformedForecasts = transformDataForChart(forecasts);
  const data = [
    {
      id: "Current FC",
      color: "hsl(339, 70%, 50%)",
      data: transformedForecasts.currentForecasts,
    },
    {
      id: "Previous FC",
      color: "hsl(242, 70%, 50%)",
      data: transformedForecasts.previousForecasts,
    },
  ];
  return (
    <ResponsiveLine
      data={data}
      margin={{
        top: 30,
        right: 150,
        bottom: 50,
        left: 80,
      }}
      yFormat=" >-0,.2~f"
      xScale={{
        type: "point",
      }}
      yScale={{
        type: "linear",
        min: -10,
        max: "auto",
        stacked: false,
        reverse: false,
      }}
      enableGridX={false}
      enableGridY={false}
      curve="cardinal"
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
      }}
      axisLeft={{
        format: (data) => formatNumbersWithCommas(data),
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
      }}
      animate={true}
      theme={{
        legends: {
          text: {
            fontSize: "14px"
          }
        },
        axis: {
          ticks: {
            text: {
              fontSize: '14px',
              fill: "#ffffff",
            },
          },
        },
      }}
      useMesh={true}
      legends={[
        {
          anchor: "bottom-right",
          direction: "column",
          justify: false,
          translateX: 100,
          translateY: 0,
          itemsSpacing: 0,
          itemDirection: "left-to-right",
          itemWidth: 80,
          itemHeight: 20,
          itemOpacity: 0.75,
          symbolSize: 12,
          symbolShape: "circle",
          symbolBorderColor: "rgba(0, 0, 0, .5)",
          itemTextColor: "#fff",
          effects: [
            {
              on: "hover",
              style: {
                itemBackground: "rgba(0, 0, 0, .03)",
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
    />
  );
};

export default SummaryShipmentPlanLineChart;
